export default {
  GET_MY_CAFE_DAILY_WORKING_HOURS_FAILED: 'GET_MY_CAFE_DAILY_WORKING_HOURS_FAILED',
  GET_MY_CAFE_DAILY_WORKING_HOURS_REJECT: 'GET_MY_CAFE_DAILY_WORKING_HOURS_REJECT',
  GET_MY_CAFE_DAILY_WORKING_HOURS_LOADING: 'GET_MY_CAFE_DAILY_WORKING_HOURS_LOADING',
  GET_MY_CAFE_DAILY_WORKING_HOURS_SUCCESS: 'GET_MY_CAFE_DAILY_WORKING_HOURS_SUCCESS',

  GET_MY_RSEE_DAILY_WORKING_HOURS_FAILED: 'GET_MY_RSEE_DAILY_WORKING_HOURS_FAILED',
  GET_MY_RSEE_DAILY_WORKING_HOURS_REJECT: 'GET_MY_RSEE_DAILY_WORKING_HOURS_REJECT',
  GET_MY_RSEE_DAILY_WORKING_HOURS_LOADING: 'GET_MY_RSEE_DAILY_WORKING_HOURS_LOADING',
  GET_MY_RSEE_DAILY_WORKING_HOURS_SUCCESS: 'GET_MY_RSEE_DAILY_WORKING_HOURS_SUCCESS',
};
